/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 * 
 */

/**
 * Faz o Arrive no Stop
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 25/03/2013
 */


Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Util = {

    getParametersToTemplate: function (labelResourceId, name, value) {
        return {
            label: Monet.I18n.getResourcesByKey(labelResourceId),
            name: name,
            value: value
        };
    },

    hideNextStopTooltip: function() { 
    
        const nextStopMenu = new Monet.UI.FloatMenu([
            { id: 1, description: '', icon: '' }
            ], {
            description: '',
            targetEl: ''
        });

        nextStopMenu.removeAllMenus('nextStopMenu');

    },

    showNextStopTooltip: function(event) {
    
        const nextStopDate = event.currentTarget 
            ? event.currentTarget.getAttribute('nextStop') 
            : event.target 
                ? event.target.nextStop 
                : null;

        const position = event.originalEvent 
            ? event.originalEvent
            : event;
        
        const formattedDate = moment(nextStopDate).format('HH:mm');
        const text = Monet.I18n.getResourcesByKey('NextStop.To.Be.Attended.Around');
        const additionalClass = 'breakLine nextStopMenu';

        const nextStopMenu = new Monet.UI.FloatMenu([
            { id: 1, description: `${text} ${formattedDate}`, icon: '' }
            ], {
            description: '',
            targetEl: ''
        });

        nextStopMenu.removeAllMenus();
        nextStopMenu.listProvider = new Monet.UI.List();
        nextStopMenu.render(position.clientX - 80, position.pageY, additionalClass);
    },

    formatStopKey: function(stopKey) {
        const encodeToUrlFriendly = (base64Encoded) => {
            return base64Encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
        }

        const hashedStopKey = Greenmile.CrossBrowserBase64.encode(stopKey);
        const friendlyEncode = encodeToUrlFriendly(hashedStopKey);
        const patternedStopKey = `hashgm:${friendlyEncode}`;

        return patternedStopKey;
    }
};